import queryString from 'query-string';
import {
	DELETE_DATA,
	GET_DATA_LIST,
	GET_DETAIL,
	SAVE_EXISTING,
	SAVE_VERSIONING,
	SUBMIT_BUDGET_PLAN,
	IMPORT_FILE,
	GET_COMPARE,
	GET_COMPARE_FILTER,
	UPDATE_STATUS,
	LOCK_BUDGET_PLAN,
	APPROVE_BUDGET_PLAN,
	GET_LIST_DEPARTMENT,
	GET_USER_BY_DEPARTMENT,
	UPLOAD_DOCUMENT,
	SEND_NOTIFICATION,
	GET_ACTIVE_PLAN,
} from '../../api/budget_plan';
import { GET_ALL_MONITORING } from '@/api/budget_monitor';

const state = {
	list: [],
	compare: [],
	detail: {},
	compareFilter: [],
	listDepartment: [],
	activePlan: {},
	selectedFundCenter: '',
	body_create: [],
	// mode: "",
};

const mutations = {
	SET_LIST_DATA: (states, payload) => {
		states.list = payload;
	},
	SET_DETAIL: (states, payload) => {
		states.detail = payload;
	},
	SET_COMPARE: (states, payload) => {
		states.compare = payload;
	},
	SET_COMPARE_FILTER: (states, payload) => {
		states.compareFilter = payload;
	},
	SET_LIST_DEPARTMENT: (states, payload) => {
		states.listDepartment = payload;
	},
	SET_ACTIVE_PLAN: (states, payload) => {
		states.activePlan = payload;
	},
	SET_SELECTED_FUND_CENTER: (states, payload) => {
		states.selectedFundCenter = payload;
	},
	SET_BODY_CREATE(state, payload) {
		state.body_create = payload;
	},

	// SET_MODE: (states, payload) => {
	//     states.mode = payload;
	// },
};

const actions = {
	SUBMIT_BUDGET_PLAN: ({}, payload) => {
		return SUBMIT_BUDGET_PLAN(payload);
	},
	GET_LIST_DATA: async ({ commit }, query) => {
		query = queryString.stringify(query);
		const resp = await GET_DATA_LIST(query);
		const data = resp.data.data;
		commit('SET_LIST_DATA', data);
	},
	GET_BUDGET_DETAIL: async ({ commit }, id) => {
		// query = queryString.stringify(query);
		const resp = await GET_DETAIL(id);
		const data = resp.data.data;
		commit('SET_DETAIL', data);
	},
	DELETE_DATA: ({}, payload) => {
		return DELETE_DATA(payload);
	},
	UPDATE_VERSIONING: ({}, payload) => {
		return SAVE_VERSIONING(payload);
	},
	UPDATE_EXISTING: ({}, payload) => {
		return SAVE_EXISTING(payload);
	},
	IMPORT_FILE: async ({ commit }, args) => {
		//return await IMPORT_FILE(args);

		const resp = await IMPORT_FILE(args);
		const data = resp.data.data;
		//console.log("isi import: ", data)
		commit('SET_BODY_CREATE', data);
	},
	GET_BUDGET_COMPARE: async ({ commit }, query) => {
		const resp = await GET_COMPARE(query);
		const data = resp.data.data;
		commit('SET_COMPARE', data);
	},
	BUDGET_COMPARE_FILTER: async ({ commit }, query) => {
		const resp = await GET_COMPARE_FILTER(query);
		const data = resp.data.data;
		commit('SET_COMPARE_FILTER', data);
	},
	UPDATE_STATUS: ({}, { id }) => {
		return UPDATE_STATUS(id);
	},
	LOCK_BUDGET_PLAN: async ({}, { id }) => {
		console.log('store plan id: ', id);
		return await LOCK_BUDGET_PLAN(id);
	},
	APPROVE_BUDGET_PLAN: async ({}, { id, reason }) => {
		console.log('store plan id: ', id);
		return await APPROVE_BUDGET_PLAN(id, reason);
	},
	GET_LIST_DEPARTMENT: async ({ commit }) => {
		const resp = await GET_LIST_DEPARTMENT();
		const data = resp.data.data;
		commit('SET_LIST_DEPARTMENT', data);
	},
	GET_USER_BY_DEPARTMENT: async ({}, query) => {
		const resp = await GET_USER_BY_DEPARTMENT(query);
		const data = resp.data.data;
		return data;
	},
	UPLOAD_DOCUMENT: async ({}, body) => {
		const resp = await UPLOAD_DOCUMENT(body);
		const data = resp.data.data || ['file_1.pdf', 'file_2.pdf'];
		return data;
	},
	SEND_NOTIFICATION: async ({}, body) => {
		const resp = await SEND_NOTIFICATION(body);
		const data = resp.data.data;
		return data;
	},
	GET_ACTIVE_PLAN: async ({ commit }) => {
		const resp = await GET_ACTIVE_PLAN();
		const data = resp.data.data;
		commit('SET_ACTIVE_PLAN', data);
	},
	SET_SELECTED_FUND_CENTER: ({ commit }, payload) => {
		commit('SET_SELECTED_FUND_CENTER', payload);
	},
};

const getters = {
	listData: (states) => states.list,
	detail: (states) => states.detail,
	compared: (states) => states.compare,
	comparedFilter: (states) => states.compareFilter,
	listDepartment: (states) => states.listDepartment,
	activePlan: (states) => states.activePlan,
	selectedFundCenter: (states) => states.selectedFundCenter,
	body_create: (states) => states.body_create,
	// mode: (states) => states.mode
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
